export default "__VITE_ASSET__C5JFkqG0__"